
      const servers_to_wake_up = [
        import.meta.env.VITE_EXT_API_URL,
        import.meta.env.VITE_PAY_API_URL,
        import.meta.env.VITE_GOV_API_URL,
      ];
      servers_to_wake_up.forEach((s) => {
        const url = new URL(s);
        url.pathname = "/wake-up";
        fetch(url);
      });
    